import { defineComponent as G, useSlots as H, computed as t, watchEffect as L, openBlock as n, createBlock as b, unref as y, withCtx as U, createElementVNode as C, normalizeClass as s, createElementBlock as m, createCommentVNode as o, renderSlot as w, mergeProps as J, resolveDynamicComponent as K, toRaw as M } from "vue";
import Q from "../CheckboxBase/CheckboxBase.vue2.js";
import { RevIllustration as X } from "@ds/components/Illustration";
import { useSelectionCardBorder as Y } from "../../composables/useSelectionCardBorder.js";
import { isString as f } from "../../utils/isString.js";
import { isValidNumber as N } from "../../utils/isValidNumber.js";
import { tw as a } from "../../utils/tailwind.js";
import { CHANGE_EVENT as Z } from "./Checkbox.constant.js";
const p = ["for"], oe = /* @__PURE__ */ G({
  name: "RevCheckbox",
  __name: "Checkbox",
  props: {
    checked: { type: [Boolean, Array], default: () => {
    } },
    modelValue: { type: [Boolean, Array], default: !1 },
    disabled: { type: Boolean, default: !1 },
    displayDescriptionOnlyWhenChecked: { type: Boolean, default: !1 },
    id: {},
    image: { default: () => {
    } },
    imageProps: { default: () => {
    } },
    value: { default: "on" },
    variant: { default: "default" }
  },
  emits: ["change", "update:modelValue"],
  setup(e, { emit: V }) {
    const g = H(), v = V, A = t(() => g.label ? e.variant !== "imageOnly" : !1), x = t(() => g.description ? e.variant === "full" : !1), u = t(() => e.value && Array.isArray(e.checked) ? e.checked.includes(e.value) : e.value && Array.isArray(e.modelValue) ? e.modelValue.includes(e.value) : e.checked !== void 0 ? e.checked : e.modelValue !== void 0 ? e.modelValue : !1);
    function B(l) {
      const r = l;
      v(Z, r);
      const W = [
        e.checked,
        e.modelValue
      ];
      for (const c of W) {
        if (typeof c == "boolean") {
          v("update:modelValue", r.target.checked);
          return;
        }
        if (Array.isArray(c)) {
          const q = r.target.checked ? [...c, e.value] : c.filter((F) => F !== e.value), z = Array.from(new Set(q));
          v("update:modelValue", z);
          return;
        }
      }
    }
    const i = t(() => {
      const l = e.imageProps || {};
      return {
        ...l,
        height: N(l.height) ? l.height : 24,
        width: N(l.width) ? l.width : 24,
        src: f(e.image) ? e.image : void 0,
        alt: f(l.alt) ? l.alt : void 0
      };
    }), E = t(() => e.variant !== "default" && f(i.value.alt));
    L(() => {
      if (e.variant === "imageOnly" && !i.value.alt)
        throw new Error(
          "Checkbox: image must have an alt text when using the ImageOnly variant."
        );
    });
    function k(l) {
      return f(l);
    }
    const D = t(() => typeof e.image == "object"), h = a`ease-in motion-safe:transition-colors motion-safe:duration-200`, O = t(() => [
      a`text-static-default-low body-2 ml-32 pt-8`,
      e.displayDescriptionOnlyWhenChecked && !u.value && a`hidden`,
      e.disabled && a`text-static-default-low-disabled`,
      h
    ]), d = t(() => e.variant !== "default"), S = t(() => [
      h,
      a`body-1 block`,
      d.value && a`rounded-sm box-border relative p-16 peer-focus-visible:outline-default-hi`,
      e.variant === "full" && a`min-h-56`,
      !e.disabled && d.value && a`bg-static-default-low hover:bg-static-default-low-hover`,
      !e.disabled && a`text-action-default-hi cursor-pointer`,
      e.disabled && d.value && a`bg-static-default-low-disabled`,
      e.disabled && a`text-action-default-hi-disabled cursor-not-allowed`
    ]), { overlayClassNames: P } = Y(
      () => !!u.value,
      () => e.disabled
    ), I = a`ml-32 flex`, R = a`flex-1 ${h}`, $ = t(() => [
      a`flex max-h-24 items-center`,
      e.variant === "full" && a`ml-16`,
      e.disabled && a`opacity-50`
    ]), j = t(() => ({
      full: a`left-16 top-20`,
      imageOnly: a`left-16 top-16 peer-focus-visible:outline-default-hi`,
      default: a`top-2 peer-focus-visible:outline-default-hi`
    })[e.variant]), T = t(() => e.variant === "full" && !u.value);
    return (l, r) => (n(), b(y(Q), {
      id: e.id,
      disabled: e.disabled,
      "is-transparent": T.value,
      label: "",
      "model-value": u.value,
      "tick-class-names": j.value,
      value: e.value,
      onChange: B
    }, {
      default: U(() => [
        C("label", {
          class: s(S.value),
          for: e.id
        }, [
          d.value ? (n(), m("div", {
            key: 0,
            "aria-hidden": "true",
            class: s(y(P))
          }, null, 2)) : o("", !0),
          C("div", {
            class: s(I)
          }, [
            A.value ? (n(), m("div", {
              key: 0,
              class: s(R)
            }, [
              w(l.$slots, "label")
            ])) : o("", !0),
            E.value ? (n(), m("div", {
              key: 1,
              class: s($.value)
            }, [
              k(i.value.src) && k(i.value.alt) ? (n(), b(y(X), J({ key: 0 }, i.value, {
                alt: i.value.alt,
                src: i.value.src
              }), null, 16, ["alt", "src"])) : o("", !0),
              D.value ? (n(), b(K(M(e.image)), {
                key: 1,
                "aria-label": i.value.alt,
                role: "img"
              }, null, 8, ["aria-label"])) : o("", !0)
            ], 2)) : o("", !0)
          ]),
          x.value ? (n(), m("div", {
            key: 1,
            class: s(O.value)
          }, [
            w(l.$slots, "description")
          ], 2)) : o("", !0)
        ], 10, p)
      ]),
      _: 3
    }, 8, ["id", "disabled", "is-transparent", "model-value", "tick-class-names", "value"]));
  }
});
export {
  oe as default
};
